var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgHomeIconFilled = function SvgHomeIconFilled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
  })));
};
export default SvgHomeIconFilled;